// extracted by mini-css-extract-plugin
module.exports = {"body":"Body_body_2rYCf","scrollable":"Body_scrollable_1T1GT"};